import './offers-grid.scss';
